import React, { createContext, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import { browserHistory } from "react-router";
import { useDispatch } from "react-redux";

function Alert(props) {
  return <MuiAlert variant="filled" elevation={6} {...props} />;
}

export const CoinContext = createContext();

const useStyles = makeStyles((theme) => ({
  styledAlert: {
    "& .MuiAlert-icon": {
      fontSize: 25,
      fontWeight: "bold",
    },
    fontSize: 15,
    fontWeight: "bold",
    // padding: "11px 0px"
  },
}));

const CoinContextProvider = (props) => {
  const dispatch = useDispatch();

  const classes = useStyles();
  let history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [wsCoinData, setWsCoinData] = useState(null);
  const [refreshOrders, setRefreshOrders] = useState(null);
  // const [openDrawer, setOpenDrawer] = useState(true);
  const [refreshBalances, setRefreshBalances] = useState(null);
  const [kycData, setKycData] = useState({});
  // const [currentTab, setCurrentTab] = useState(0)

  const [openAlert, setOpenAlert] = useState(false);
  // const [severity, setSeverity] = useState("info");
  // const [messageAlert, setMessageAlert] = useState(null);
  const [openDialog, setDialog] = useState(false);

  var dialogType = "";

  const updateData = (data) => {
    setWsCoinData(data);
  };

  const updateOrders = (id) => {
    setRefreshOrders(id);
  };

  // const updateDrawer = (pos) => {
  //   setOpenDrawer(pos);
  // };

  const updateBalances = (id) => {
    setRefreshBalances(id);
  };

  const updateKycData = (data) => {
    setKycData(data);
  };

  const handleClickAlert = (variant, message) => {
    // setSeverity(type);
    // setMessageAlert(message);
    // setOpenAlert(true);
    enqueueSnackbar(message, {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
      variant,
      preventDuplicate: true,
      // persist: true
    });
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  function bannedTimeout(type) {
    // alert("PLz logout");
    dialogType = type;
    handleDialogOpen();
  }

  const handleDialogOpen = () => {
    setDialog(true);
  };

  const handleDialogClose = () => {
    setDialog(false);
    handleLogout();
  };

  function handleLogout() {
    // console.log("Logging out");
    dispatch({ type: "SET_TOKEN", payload: null });
    dispatch({ type: "SET_TOKEN_STATUS", payload: null });
    dispatch({ type: "SET_LOGIN_ID", payload: null });

    window.fcWidget.user.clear();
    history.push(`/login`);
  }

  // history.listen((location) => {
  //   console.log(location)
  // })

  return (
    <CoinContext.Provider
      value={{
        wsCoinData,
        updateData,
        refreshOrders,
        updateOrders,
        refreshBalances,
        updateBalances,
        kycData,
        updateKycData,
        handleClickAlert,
        bannedTimeout,
      }}
    >
      <>
        {/* <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={openAlert}
          onClose={handleCloseAlert}
          autoHideDuration={6000}
        >
          <Alert
            onClose={handleCloseAlert}
            severity={severity}
            className={classes.styledAlert}
          >
            {messageAlert}
          </Alert>
        </Snackbar> */}

        {props.children}
      </>
    </CoinContext.Provider>
  );
};

export default CoinContextProvider;
